import {useId} from 'react';
import homePatch from '@/assets/hd-ui-v1/home-patches.webp';
import careerPatch from '@/assets/hd-ui-v1/career-patches.webp';
import homeCoverage from '@/assets/hd-ui-v1/home-coverage.webp';
import careerCoverage from '@/assets/hd-ui-v1/career-coverage.webp';
import navy from '@/assets/hd-ui-v1/navy-inlay.webp';
import zones from './hdZones.json';

// Only authorized component zones are removed. Employee source stays immutable.
export default function HdScene({src,page='home',className=''}) {
 const id=useId().replace(/:/g,'');const z=zones.pages[page];const [w,h]=z.size;
 const header=z.header_path;
 return <svg className={`hd-scene ${className}`} viewBox={`0 0 ${w} ${h}`} preserveAspectRatio={page==='career'?'none':'xMidYMin meet'} aria-hidden="true" data-hd-scene={page}>
  <defs><mask id={`hd-locked-${id}`} maskUnits="userSpaceOnUse" x="0" y="0" width={w} height={h}>
   <image href={page==='home'?homeCoverage:careerCoverage} width={w} height={h}/>{header&&<path d={header} fill="black"/>}
  </mask>{header&&<clipPath id={`hd-header-${id}`}><path d={header}/></clipPath>}</defs>
  <image data-locked-source href={src} width={w} height={h} mask={`url(#hd-locked-${id})`}/>
  <image data-clean-zones href={page==='home'?homePatch:careerPatch} width={w} height={h}/>
  {header&&<image href={navy} x="740" y="0" width="530" height="124" preserveAspectRatio="none" clipPath={`url(#hd-header-${id})`}/>}
 </svg>;
}
